/** The How to play pages' words (docs/spec/07 §2): a title and a sentence or two each. Pure. */

export interface HelpPage {
  readonly title: string;
  readonly text: string;
}

export const PAGES: readonly HelpPage[] = [
  {
    title: 'THE GOAL',
    text: 'COLLECT ENOUGH DIAMONDS TO OPEN THE EXIT, THEN REACH IT BEFORE THE TIME RUNS OUT.',
  },
  {
    title: 'DIGBY, DIRT AND DIAMONDS',
    text: 'DIGBY TUNNELS THROUGH DIRT AND PICKS UP DIAMONDS. '
      + 'THE EXIT LOOKS LIKE STEEL UNTIL ENOUGH ARE FOUND - THEN IT FLASHES.',
  },
  {
    title: 'BOULDERS',
    text: 'BOULDERS FALL, AND ROLL OFF ANYTHING ROUND. PUSH ONE SIDEWAYS INTO A GAP. '
      + 'HOLD GRAB WITH A DIRECTION TO TAKE WITHOUT MOVING.',
  },
  {
    title: 'FIREFLIES AND BUTTERFLIES',
    text: 'ONE TOUCH OF EITHER IS DEADLY. DROP A BOULDER ON A FIREFLY TO BLOW IT UP - '
      + 'OR ON A BUTTERFLY FOR NINE DIAMONDS.',
  },
  {
    title: 'AMOEBA AND MAGIC WALL',
    text: 'AMOEBA SPREADS: TRAP IT AND IT TURNS TO DIAMONDS, LET IT GROW TOO BIG AND IT TURNS TO BOULDERS. '
      + 'A MAGIC WALL TURNS BOULDERS INTO DIAMONDS.',
  },
  {
    title: 'THE DEEP',
    text: 'THE DEEP ADDS WALLS THAT GROW, SLIME THAT THINGS SEEP THROUGH, '
      + 'KEYS THAT OPEN DOORS OF THEIR COLOUR AND CLOCKS WORTH 10 SECONDS.',
  },
  {
    title: 'SCORING AND LIVES',
    text: 'YOU START WITH 3 MEN. EVERY FIFTH CAVE IS A BONUS: FINISH IT FOR AN EXTRA MAN - '
      + 'FAILING THERE COSTS NOTHING.',
  },
  {
    title: 'CONTROLS',
    text: 'CHANGE THE KEYS IN OPTIONS. PAUSE AT ANY TIME TO CHANGE OPTIONS OR RESTART A CAVE, WHICH COSTS A MAN.',
  },
];
